
import Hangman from './hangman'
import getPuzzle from './requests'


window.addEventListener('keypress', (e) =>  {
    const guess = String.fromCharCode(e.charCode)
    game1.makeGuess(guess)
    render()
})
let game1 
const puzzleEl = document.querySelector('#puzzle')
const guessesEl = document.querySelector('#guesses')


const render = () => {
    puzzleEl.innerHTML = ''
    guessesEl.textContent = game1.statusMessage

   game1.puzzle.split('').forEach((letter) => {
       const letterEl = document.createElement('span')
       letterEl.textContent = letter
       puzzleEl.appendChild(letterEl)
   })
}
const startGame = async () => {
 const puzzle = await getPuzzle('2')
 game1 = new Hangman(puzzle, 5)
 render()
}

document.querySelector('#reset').addEventListener('click', startGame)

startGame()


// getPuzzle('2').then((puzzle) => {
//     console.log(puzzle)
// }).catch((err) => {
//     console.log(`Error: ${err}`)
// })
// Making an HTTP request

// countryCodeCall('AM').then((country) => {
//     console.log(country.name)
// }).catch((err) => {
//     console.log(`Error: ${err}`)
// })

// getCurrentCountry().then((country) => {
//     console.log(country.name)
// }).catch((error) => {
//     console.log(error)
// })



// // getLocation().then((location) => {
// //    return countryCodeCall(location.country)
// // }).then((country) => {
// //     console.log(`You are currently in the ${country.name}`)
// // }).catch((err) => {
// //     console.log(`Error: ${err}`)
// // })



// getWeather().then((weather) => {
//     console.log(`Your current weather is ${weather.currently.summary}`)
//     console.log(weather)
// })

// fetch('httP://puzzle.mead.io/puzzle', {}).then((response) => {
//     if (response.status === 200) {
//         return response.json()                  
//     } else {
//         throw new Error('Unable to fetch puzzle')
//     }
// }).then((data) => {
//     console.log(data.puzzle)
// }).catch((error) => {
//     console.log(error)
// })